// Lib imports
import React, { FunctionComponent, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// Types
import { ModalNames } from 'ducks/merchantDucks/modal/types';
import { PerAssetEmbedCodeOptions } from 'ducks/merchantDucks/embedding/types';

// Actions
import { setPerAssetEmbedCodeObject, resetPerAssetOptions } from 'ducks/merchantDucks/embedding/actions';
import { loadApplications } from 'ducks/merchantDucks/oauth/actions';

// Selectors
import { getPerAssetOption } from 'ducks/merchantDucks/embedding/selectors';
import { getItemDetails } from 'ducks/merchantDucks/items/selectors';

// Components
import BaseModal from 'components/Modals/BaseModal';
import EmbedSettings from 'pages/MerchantPages/Assets/components/Navbar/modals/components/EmbedSettings';
import EmbedCode from 'pages/MerchantPages/Assets/components/Navbar/modals/components/EmbedCode';

interface OwnProps {
  isAdvancedEmbedding?: boolean;
}

type Props = OwnProps;

const EmbedModal: FunctionComponent<Props> = ({ isAdvancedEmbedding = false }) => {
  const dispatch = useDispatch();

  // Selectors
  const { id: assetId } = useSelector(getItemDetails);
  const perAssetId = useSelector(getPerAssetOption(PerAssetEmbedCodeOptions.ASSET_ID));

  useEffect(() => {
    // Load customer oaut applications here to avoid late dropdown rendering
    dispatch(loadApplications());
  }, []);

  const resetEmbedOptions = () => {
    if (assetId.toString() !== perAssetId) {
      dispatch(resetPerAssetOptions());
    }

    dispatch(setPerAssetEmbedCodeObject(PerAssetEmbedCodeOptions.ASSET_ID, assetId.toString()));
  };

  return (
    <BaseModal
      modalName={ModalNames.Embed}
      title="Get asset embed code"
      onOpen={resetEmbedOptions}
      render={() => (
        <>
          {!isAdvancedEmbedding && <EmbedSettings />}
          <EmbedCode />
        </>
      )}
    />
  );
};

export default EmbedModal;
